import React from 'react'

const Prospect360 = () => {
  return (
    <div>Prospect360</div>
  )
}

export default Prospect360